import { inject } from "@angular/core";
import { CanActivateFn, CanMatchFn, Router, UrlTree } from "@angular/router";
import { FeatureFlagService } from "./featureFlag.service";

/**
 * Route gating for feature flags. Allows the route only when `feature` is enabled
 * (per the API-resolved set), otherwise redirects to `redirectTo` (default "/").
 *
 * canMatch (preferred — also stops the lazy-loaded chunk from loading):
 *   { path: "Beta", canMatch: [featureFlagCanMatch(FeatureFlags.SomeFlag)], loadComponent: ... }
 *
 * canActivate (drop-in for the app's existing canActivate arrays):
 *   { path: "Beta", canActivate: [canActivateGuard, featureFlagCanActivate(FeatureFlags.SomeFlag)], ... }
 */
export function featureFlagCanMatch(feature: string, redirectTo: string = "/"): CanMatchFn {
  return () => resolve(feature, redirectTo);
}

export function featureFlagCanActivate(feature: string, redirectTo: string = "/"): CanActivateFn {
  return () => resolve(feature, redirectTo);
}

function resolve(feature: string, redirectTo: string): boolean | UrlTree {
  if (inject(FeatureFlagService).isEnabled(feature)) {
    return true;
  }

  return inject(Router).parseUrl(redirectTo);
}
